import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import WorkflowLaunchService from 'src/modules/workflowLaunch/workflowLaunchService';

const prefix = 'WORKFLOWLAUNCH_VIEW';

const workflowLaunchViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: workflowLaunchViewActions.FIND_STARTED,
      });
      const record = await WorkflowLaunchService.find(id);
      dispatch({
        type: workflowLaunchViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: workflowLaunchViewActions.FIND_ERROR,
      });
      getHistory().push('/workflow-launch');
    }
  },
};

export default workflowLaunchViewActions;
